import React, { useContext } from 'react';
import './styles/App.css';
import { BrowserRouter } from 'react-router';
import AppRouter from './components/AppRouter';
import { observer } from 'mobx-react-lite';
import { MainContext } from '.';

const App = observer(() => {
    const { user } = useContext(MainContext);
    if (user.isLoading) {
        return <div>Loading...</div>;
    }

    return (
        <div className="App">
            <BrowserRouter>
                <AppRouter />
            </BrowserRouter>
        </div>
    );
});

export default App;

